<template>
    <div class="flex flex-col justify-center items-center landscape:flex-row p-4 relative overflow-hidden">
        <div v-for="avaria in croquisAvarias" :key="avaria.nome" class="">
            <img class="w-72 h-60" :class="avaria.tipoVeiculo == tipoCaminhao ? 'rotate-[20deg]' : ''"
                :src="avaria.imagem" alt="">
            <div v-if="avaria.semAvaria" class="absolute flex left-0 top-0 flex-wrap justify-evenly">
                <span v-for="n in 150" :key="n" class="relative text-[#2828288e] text-base opacity-50">Sem Avaria
                    &nbsp;</span>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'AvariaResumo',
    props: {
        croquisAvarias: {
            type: Array,
            required: true
        },
        tipoCaminhao: {
            type: String,
            required: true
        }
    }
});
</script>
